module.exports = __webpack_public_path__ + "img/Recharge(1).86fa7a76.png";